// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var DeviceType_Enum;
(function (DeviceType_Enum) {
    DeviceType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    DeviceType_Enum["DESK_PHONE"] = "DESK_PHONE";
    DeviceType_Enum["SOFTPHONE"] = "SOFTPHONE";
    DeviceType_Enum["MOBILE_APP"] = "MOBILE_APP";
})(DeviceType_Enum || (DeviceType_Enum = {}));
export var DeviceType_Enum_index;
(function (DeviceType_Enum_index) {
    DeviceType_Enum_index[DeviceType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    DeviceType_Enum_index[DeviceType_Enum_index["DESK_PHONE"] = 1] = "DESK_PHONE";
    DeviceType_Enum_index[DeviceType_Enum_index["SOFTPHONE"] = 2] = "SOFTPHONE";
    DeviceType_Enum_index[DeviceType_Enum_index["MOBILE_APP"] = 3] = "MOBILE_APP";
})(DeviceType_Enum_index || (DeviceType_Enum_index = {}));
export const SipProfileAPI = {
    List(fn, req) {
        return fn(`/phone/sip-profiles/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
